import { useMemo } from 'react';
import { DateGroupingKey } from '@blisspointmedia/bpm-types/dist/FiscalCalendar';
import { useCompanyInfo } from '@src/utils/hooks/useCompanyInfo';
import { groupChartDataByDate } from './BrandEquityUtils';

// Re-groups weekly chart data by the selected date granularity (Week/Month/Quarter) against
// the company's fiscal calendar. Shared by the Overview + leaf chart widgets, which each wrapped
// `groupChartDataByDate` in an identical guard-then-memo. Returns [] until data is present.
export const useGroupedByDate = <T>(data: T[], grouping: DateGroupingKey): T[] => {
  const { fiscal_cal: fiscalCal } = useCompanyInfo();
  return useMemo(() => {
    if (data.length > 0) {
      return groupChartDataByDate(data, grouping, fiscalCal);
    }
    return [];
  }, [data, grouping, fiscalCal]);
};
